// extracted by mini-css-extract-plugin
export default {"splash":"Splash_splash__VSBqM","splash__logo":"Splash_splash__logo__iZHyQ","splash__dialogue-ending":"Splash_splash__dialogue-ending__ry5Zk"};